import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { VirtualConnectionTableDownstreamSheetsQueryVariables, VirtualConnectionTableDownstreamSheetsQuery, SheetsDisplayGridRowDataFragment, VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables, VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery, SheetSortOrder , VirtualConnectionTableDownstreamSheetsFilteredByColumnDocument , VirtualConnectionTableDownstreamSheetsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { getRowDataForSheet, SheetsDisplayGrid, SheetsDisplayGridRowData } from '../sharedDisplayGrid/SheetsDisplayGrid';
import { SheetsValidSortFields } from '../sorting/sortProviders/SheetsGridSortProvider';


type QueryVariables = VirtualConnectionTableDownstreamSheetsQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamSheetsQuery;
type QueryResultListNode = SheetsDisplayGridRowDataFragment;
type GridRowData = SheetsDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery;
type QueryResultListNodeWithFilter = SheetsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
    resultData.virtualConnectionTables[0].downstreamSheetsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamSheetsConnection : null;
}

export type VirtualConnectionTableDownstreamSheetsQueryGridProps = GridSortProps<SheetsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
};

export function VirtualConnectionTableDownstreamSheetsQueryGrid(props: VirtualConnectionTableDownstreamSheetsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamSheetsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredSheetsLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Sheet as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamSheetsFilteredByColumnDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as SheetSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) =>
        <SheetsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamSheetsDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as SheetSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) =>
        <SheetsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
    </PaginatedQueryWrapper>
  );
}
